export function useAltchaCaptcha(): { enabled: boolean; challengeUrl: string | null } {
  const url = (import.meta.env.VITE_ALTCHA_CHALLENGE_URL ?? '') as string;
  return { enabled: !!url, challengeUrl: url || null };
}
